import Phaser from 'phaser';

import MainScene from './scenes/Main';
import GameOverScene from './scenes/GameOver';

const BunnyInfinity = {
  type: Phaser.AUTO,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 480,
    height: 640,
  },
  scene: [MainScene, GameOverScene],
  physics: {
    default: 'arcade',
    arcade: {
      gravity: {
        y: 200,
      },
    },
  },
};

export default BunnyInfinity;
